import * as ko from 'knockout';
import { Observable, ObservableArray } from 'knockout';
import { publicSiteService } from '../../../api/service.publicsite';
import { displayImageBasePath, productImageBasePath } from '../../../utils/const';
import { formatPrice, formatWeight } from '../../../utils/format';

type ProductBlockType = {
  heading: string;
  headingImage: Observable<string>;
  products: ProductType[];
}

type VideosImagesType = {
  type: string;
  url: string;
  timeoutSecs: number;
}

type ProductType = {
  productId: number;
  product: string;
  size: string;
  pricing: string;
  unitPrice: number;
  specialPricing: string;
  isOnSpecial: boolean;
  isCat: boolean;
  isDog: boolean;
  imageUrl: string | null;
  weight: number;
}

class PricingSmall {
  readonly productBlock1: ObservableArray<ProductBlockType>;
  readonly productBlock2: ObservableArray<ProductBlockType>;
  readonly productBlock3: ObservableArray<ProductBlockType>;
  readonly allProductsArray: ObservableArray<ProductType>;
  readonly adProduct = ko.observable<string>('');
  readonly adPricing = ko.observable<string>('');
  readonly adSpecial = ko.observable<string>('');
  readonly adImage = ko.observable<string>('');
  readonly adDescription = ko.observable<string>('');
  readonly selectedAdvertProductId = ko.observable<number>(0);

  readonly clockTime = ko.observable<string>('');

  readonly doodleImage = ko.observable(`${displayImageBasePath}/doodledoodle.png`);
  readonly logoImage = ko.observable(`${displayImageBasePath}/NZ-Black-Logo.png`);

  readonly tempAdverts: any[] = [];

  readonly blockComplete = {
    block1: ko.observable<boolean>(false),
    block2: ko.observable<boolean>(false),
    block3: ko.observable<boolean>(false)
  };

  readonly iteration = 0;
  block3Timeout: NodeJS.Timeout | null;

  constructor() {
    this.productBlock1 = ko.observableArray();
    this.productBlock2 = ko.observableArray();
    this.productBlock3 = ko.observableArray();
    this.allProductsArray = ko.observableArray();
    this.block3Timeout = null;

    // Get current time.
    this.getTime();

    this.getProducts();
  }

  getTime = () => {
    const currentTime = new Date();

    this.clockTime(currentTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }));
    setTimeout(this.getTime, 1000);
  }

  getProducts = () => {

    this.getBlock1();
    this.getBlock2();
    this.getBlock3();

    //setTimeout(this.getProducts, 60000 * 15);
    setTimeout(() => window.location.reload(), 60000 * 15);
  }

  getBlock1 = async () => {
    const blockSections: ProductBlockType[] = [];

    await publicSiteService.getDisplayProducts([8])
      .then(results => {
        results.forEach(s => {

          const total = s.products.length;

          const products: ProductType[] = s.products.slice(17).map((p: any) => {

            const isOnSale = p.salePrice > 0;

            return {
              productId: p.productId,
              product: p.name,
              salePrice: p.salePrice,
              isOnSale: p.salePrice > 0,
              size: formatWeight(p.unitWeight),
              pricing: isOnSale ? `Now ${formatPrice(p.salePrice)}` : formatPrice(p.retailRRP),
              isCat: p.isCat,
              isDog: p.isDog,
              imageUrl: p.imageUrl != null ? `${productImageBasePath}/${p.imageUrl}` : '',
              weight: p.unitWeight,
              unitPrice: isOnSale ? p.salePrice : p.retailRRP,
              fontSize: p.name.length > 35 ? 0.4 : 0.4,
            }
          });

          const image = ko.observable('');

          const images = products.filter(p => p.imageUrl != '').map(p => p.imageUrl);

          if (images.length > 0) {
            const rand = Math.floor(Math.random() * images.length);
            image(images[rand] as string);
          }

          const chunkSize = 28;
          for (let i = 0; i < products.length; i += chunkSize) {
            const chunk: ProductType[] = products.slice(i, i + chunkSize);

            blockSections.push({ heading: s.title, headingImage: image, products: chunk });
          }
        });
      });

    await publicSiteService.getDisplayProducts([9])
      .then(results => {

        results.forEach(s => {

          const products: ProductType[] = s.products.map((p: any) => {

            const isOnSale = p.salePrice > 0;

            return {
              productId: p.productId,
              product: p.name,
              salePrice: p.salePrice,
              isOnSale: p.salePrice > 0,
              size: formatWeight(p.unitWeight),
              pricing: isOnSale ? `Now ${formatPrice(p.salePrice)}` : formatPrice(p.retailRRP),
              isCat: p.isCat,
              isDog: p.isDog,
              imageUrl: p.imageUrl != null ? `${productImageBasePath}/${p.imageUrl}` : '',
              weight: p.unitWeight,
              unitPrice: isOnSale ? p.salePrice : p.retailRRP,
              fontSize: p.name.length > 35 ? 0.4 : 0.4,
            }
          });

          const image = ko.observable('');

          const images = products.filter(p => p.imageUrl != '').map(p => p.imageUrl);
          if (images.length > 0) {
            const rand = Math.floor(Math.random() * images.length);
            image(images[rand] as string);
          }

          blockSections.push({ heading: s.title, headingImage: image, products });
        });
      });

    this.productBlock1(blockSections);
    this.populateAllProductsArray(blockSections);
    this.blockComplete.block1(true);
    //setTimeout(this.getBlock1, 60000 * 15);
  }

  getBlock2 = async () => {
    const blockSections: ProductBlockType[] = [];

    await publicSiteService.getBulkDisplayProducts([9])
      .then(results => {
        results.forEach(s => {

          const products: ProductType[] = s.products.map((p: any) => {

            const isOnSale = p.salePrice > 0;

            return {
              productId: p.productId,
              product: p.name,
              salePrice: p.salePrice,
              isOnSale: p.salePrice > 0,
              size: formatWeight(p.unitWeight),
              pricing: isOnSale ? `Now ${formatPrice(p.salePrice)}` : formatPrice(p.retailRRP),
              isCat: p.isCat,
              isDog: p.isDog,
              imageUrl: p.imageUrl != null ? `${productImageBasePath}/${p.imageUrl}` : '',
              weight: p.unitWeight,
              unitPrice: isOnSale ? p.salePrice : p.retailRRP,
              fontSize: p.name.length > 35 ? 0.4 : 0.4,
            }
          });

          const image = ko.observable('');

          const images = products.filter(p => p.imageUrl != null).map(p => p.imageUrl);
          if (images.length > 0) {
            const rand = Math.floor(Math.random() * images.length);
            image(images[rand] as string);
          }
          blockSections.push({ heading: s.title, headingImage: image, products });
        });
      });

    this.productBlock2(blockSections);

    this.populateAllProductsArray(blockSections);
    this.blockComplete.block2(true);

    //setTimeout(this.getBlock2, 60000 * 15);
  }

  getBlock3 = async () => {
    const blockSections: ProductBlockType[] = [];

    await publicSiteService.getDisplayProducts([8])
      .then(results => {
        results.forEach(s => {

          const products: ProductType[] = s.products.slice(0, 17).map((p: any) => {

            const isOnSale = p.salePrice > 0;

            return {
              productId: p.productId,
              product: p.name,
              salePrice: p.salePrice,
              isOnSale: p.salePrice > 0,
              size: formatWeight(p.unitWeight),
              pricing: isOnSale ? `Now ${formatPrice(p.salePrice)}` : formatPrice(p.retailRRP),
              isCat: p.isCat,
              isDog: p.isDog,
              imageUrl: p.imageUrl != null ? `${productImageBasePath}/${p.imageUrl}` : '',
              weight: p.unitWeight,
              unitPrice: isOnSale ? p.salePrice : p.retailRRP,
              fontSize: p.name.length > 35 ? 0.4 : 0.45,
            }
          });

          const image = ko.observable('');

          const images = products.filter(p => p.imageUrl != '').map(p => p.imageUrl);

          if (images.length > 0) {
            const rand = Math.floor(Math.random() * images.length);
            image(images[rand] as string);
          }

          const chunkSize = 28;
          for (let i = 0; i < products.length; i += chunkSize) {
            const chunk: ProductType[] = products.slice(i, i + chunkSize);

            blockSections.push({ heading: s.title, headingImage: image, products: chunk });
          }
        });
      });

    this.productBlock3(blockSections);

    this.populateAllProductsArray(blockSections);
    this.blockComplete.block3(true);
  }

  startBlock3 = (iteration: number) => {

    
  }

  populateAllProductsArray = (sections: ProductBlockType[]) => {
    const allProducts = this.allProductsArray();

    sections.forEach(s => {
      s.products.forEach((p: ProductType) => {

        //if (p.imageUrl !== '') {
        //  allProducts.push(p);
        //}

        allProducts.push(p);
      });
    });

    this.allProductsArray(allProducts);
  }
}

export default {
  name: 'display-pricing-small',
  viewModel: PricingSmall,
  template: require('./pricingSmall.html')
};
